// @flow
import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';
import auth, {
  actions as AuthActions, getSessionEpic, /*setCustomSessionEpic, executeAfterCustomCookieSetEpic,
  executeAfterIndexCookieSetEpic,*/ logoutCustomSessionEpic, loginEpic, loginFbEpic,
  registerEpic, redirectAfterSuccess, logoutEpic, changeLanguageAfterSuccessEpic,
  initialState as authInitialState, setTrackingSessionEpic,
} from './auth/duck';
import navbar, { initialState as navbarInitialState } from './navbar/duck';
import home, {
  // subscribeEpic,
  fetchWishListEpic,
  initialState as homeInitialState,
} from './home/duck';
import unsubscribe, {
  editHasCampaignMailNewsletterEpic,
  initialState as UnsubscribeInitialState,
} from './unsubscribe/duck';
import abTest, {
  initialState as ABTestInitialState,
} from './ab-test/duck';
import {
  fetchNotificationsEpic, fetchUnseenEpic, readNotificationEpic,
  seeAllNotificationEpic, hideNotificationEpic, fetchNotificationsSuccessEpic,
} from './navbar/notifications/duck';
import preferences, { initialState as preferencesInitialState } from './preferences/duck';
import { editProfileEpic, editImageProfileEpic } from './preferences/edit-profile/duck';
import {
  editNotificationsSettingsEpic, fetchNotificationSettingsEpic,
} from './preferences/notifications/duck';
import {
  deleteAddressEpic, fetchAddressesEpic, postAddressEpic, editAddressEpic,
} from './preferences/saved-addresses/duck';
import { editEmailEpic, postPhoneEpic, postCodeEpic } from './preferences/security/duck';
import { editPasswordEpic } from './preferences/password/duck';
import { deletePayoutEpic, fetchPayoutsEpic, postPayoutEpic, postPayoutPayPalEpic } from './preferences/payouts/duck';
import { deletePaymentEpic, editPaymentEpic, postPaymentEpic } from './preferences/payments/duck';
import newFlight, { postFlightEpic, initialState as newFlightInitialState } from './new-flight/duck';
import flightLanding, { fetchFlightLandingFlightEpic, saveDataLandingFlightEpic, initialState as flightLandingInitialState } from './flight-landing/duck';
import newOrder, {
  initialState as newOrderInitialState,
  postOrderEpic,
  postOrderImageEpic,
  redirectNewOrderToCheckoutAfterSuccess,
  /*postNewOrderCheckoutAddressEpic, editNewOrderCheckoutAddressEpic,
  deleteNewOrderCheckoutAddressEpic,
  getLastContactInfoEpic,*/
} from './new-order/duck';
import {
  initialState as quoteStepInitialState,
  newOrderQuoteForecastPricesEpic,
  newOrderQuotePostMissingCartEpic,
  newOrderQuotePostMissingSumItemsEpic,
  newOrderQuoteFetchRelatedProductsEpic,
} from './new-order/QuoteStep/duck';
import {
  initialState as productStepInitialState,
  newOrderProductFetchWishListsEpic, newOrderProductPostProductToWishListEpic,
  newOrderProductPostProductToWishListImageEpic, newOrderProductPostNewWishListEpic,
  newOrderProductQuoteForecastPricesEpic,
} from './new-order/ProductStep/duck';
import {
  initialState as checkoutStepInitialState,
  fetchCheckoutStepOrderEpic, fetchNewOrderCheckoutAddressesEpic, fetchNewOrderCheckoutPaymentMethodsEpic,
  postNewOrderCheckoutItemsOrderAndTokenEpic,
  postNewOrderCheckoutCartOrderAndTokenEpic, postNewOrderCheckoutBagOrderAndTokenEpic,
  setSuccessfulCreateOrderTracking,
  putNewOrderCheckoutOrderPaymentMethodEpic, postNewOrderCheckoutPaymentExecuteEpic,
  newOrderCheckoutRedirectToSuccessPageEpic,
  postNewOrderCheckoutPaymentExecuteCustomHandleErrorEpic,
  newOrderCheckoutAsyncPaymentRedirectToOrderPageEpic,
  newOrderCheckoutNotFoundLibraryErrorEpic,
  newOrderCheckoutApplyCoupon,
  newOrderCheckoutRemoveCoupon,
} from './new-order/CheckoutStep/duck';
import { searchProductEpic } from './new-order/SearchStep/duck';
import {
  checkoutSuccessFetchOrderEpic,
  initialState as checkoutSuccessInitialState,
} from './new-order/CheckoutSuccessStep/duck';
import flights, {
  fetchActiveFlightsEpic,
  fetchPastFlightsEpic,
  deleteActiveFlightEpic,
  initialState as flightsInitialState,
} from './flights/duck';
import editFlight, {
  editFlightEpic,
  fetchFlightEpic,
  initialState as editFlightInitialState,
} from './edit-flight/duck';
import orders, {
  fetchActivePurchasesEpic,
  fetchPastPurchasesEpic,
  cancelOrDeleteOrderEpic,
  initialState as ordersInitialState,
} from './orders/duck';
import flight, {
  fetchFlightFlightEpic,
  fetchAvailableRequestsEpic,
  fetchFlightSalesEpic,
  fetchTravelerRewardEpic,
  initialState as flightInitialState,
} from './flight/duck';
import localValues, {
  fetchCategoriesEpic,
  fetchCountriesEpic,
  fetchStoreCategoriesEpic,
  fetchOnlineStoresEpic,
  initialState as localValuesInitialState,
} from './local-values/duck';
import reserve, {
  fetchReserveFlightEpic,
  fetchReserveOrderEpic,
  postReserveEpic,
  updatePhoneEpic,
  initialState as reserveInitialState,
} from './reserve/duck';
import locale, { initialState as localeInitialState } from './locale/duck';
import order, {
  initialState as orderInitialState,
  fetchOrderEpic,
  fetchMessagesEpic,
  postOrderMessageEpic,
  updateTransactionRealTimeEpic,
} from './order/duck';
import {
  purchaseUnconfirmedPaymentDeleteOrderEpic,
} from './order/Purchase/unconfirmed-payment/duck';
import {
  cancelOrderEpic,
} from './order/Purchase/looking-for-traveler/duck';
import {
  registerPurchaseUploadInvoiceFileEpic,
  registerPurchaseUploadInvoiceEpic,
  registerPurchasePostIdentityEpic,
  registerPurchaseProgressPurchaseEpic,
} from './order/Purchase/register-purchase/duck';
import {
  setCourierFlowTrackingNumberEpic,
} from './order/Purchase/courier-flow/duck';
import {
  postConfirmationEpic,
} from './order/Purchase/in-transit/duck';
import {
  postFeedbackEpic,
} from './order/Purchase/feedback/duck';
import {
  uploadInvoiceFileEpic,
  uploadInvoiceEpic,
  progressPurchaseEpic,
  cancelReserveEpic,
} from './order/Sale/reserved/duck';
import {
  setTrackingNumberEpic,
  confirmItemReceivedEpic,
  progressReceiveEpic,
  fetchCancellationMotivesEpic,
  cancelPurchasedItemEpic,
} from './order/Sale/purchased/duck';
import { confirmArrivalEpic } from './order/Sale/received/duck';
import {
  postProgressCourierInvoiceEpic,
  postProgressCourierEpic,
  postProgressQempoEpic,
  fetchCouriersEpic,
} from './order/Sale/deliver/duck';
import { fetchDisbursementInfoEpic } from './order/Sale/completed/duck';
import payments, {
  fetchPaymentsMadeEpic,
  fetchPaymentsReceivedEpic,
  initialState as paymentsInitialState,
} from './payments/duck';
import alert, { initialState as alertInitialState } from './alert/duck';
import { routerReducer } from '../router';
import authModals, {
  fetchSessionEpic,
  resendVerificationEpic,
  sendForgotPasswordEpic,
  recoverUserEpic,
  initialState as authModalsInitialState,
} from './auth/auth-modals/duck';
import report, {
  reportEpic,
  reportImageEpic,
  motivesEpic,
  initialState as reportInitialState,
} from './report/duck';
import deals, {
  fetchDealsEpic,
  initialState as dealsInitialState,
} from './best-deals/duck';
import shoppingCart, {
  deleteItemEpic, deleteShoppingCartEpic, deleteShoppingCartItemsEpic, postShoppingCartItemEpic, 
  postShoppingCartItemImageEpic, editShoppingCartItemEpic, fetchShoppingCartEpic,
  postVirtualShoppingCartItemEpic, editVirtualShoppingCartItemEpic, deleteVirtualCartItemEpic,
  postVirtualCartToCartDeleteEpic, postVirtualCartToCartImageEpic, postVirtualCartToCartEpic,
  forecastShoppingCartItemEpic,
  initialState as shoppingCartInitialState,
} from './shopping-cart/duck';
import bag, {
  postBagItemEpic,
  postBagItemImageEpic,
  resetBagEpic,
  fetchBagEpic,
  editBagItemEpic,
  deleteBagItemEpic,
  postVirtualBagItemEpic,
  editVirtualBagItemEpic,
  deleteVirtualBagItemEpic,
  postVirtualBagToBagImageEpic,
  postVirtualBagToBagEpic,
  initialState as bagInitialState,
} from './bag/duck';
import stores, {
  fetchStoresEpic,
  initialState as storesInitialState,
} from './stores/duck';
import store, {
  fetchStoreEpic,
  StoreGetUserWishList1Epic,
  StoreGetUserWishList2Epic,
  initialState as storeInitialState,
} from './store/duck';
import productList, {
  fetchProductListEpic,
  initialState as productListInitialState,
} from './product-list/duck';
import wishList, {
  getListUserWishListsEpic,
  getUserWishListEpic,
  postWishListImageEpic,
  postCreateUserWishListEpic,
  putEditUserWishListEpic,
  deleteUserWishListEpic,
  postProductEpic,
  postProductImageEpic,
  editProductEpic,
  editProductImageEpic,
  deleteProductEpic,
  editWishListLikeEpic,
} from './wish-list/duck'
import featuredProducts, {
  fetchFeaturedProductsEpic as fetchFeaturedProductsPageEpic,
  initialState as featuredProductsInitialState,
} from './featured-products/duck';

import popularProducts, {
  fetchPopularProductsEpic as fetchPopularProductsPageEpic,
  initialState as popularProductsInitialState,
} from './popular-products/duck';

import punchCard, {
  fetchPunchCardPointsEpic, claimPunchCardPointsEpic,
  initialState as punchCardInitialState,
} from './punch-card/duck';

import productHelper, {
  productHelperPostContactMessageEpic,
  initialState as productHelperInitialState,
} from './product-helper/duck';
import cargo, {
  cargoPostContactMessageEpic,
  initialState as cargoInitialState,
} from './cargo/duck';
import wishListCatalog, {
  fetchWishListsEpic,
  initialState as wishListCatalogInitialState,
} from './wish-list-catalog/duck';
import myWishLists, {
  fetchMyWishListsEpic,
  postWishListEpic,
  putWishListEpic,
  postWishListImageEpic as wishListsPostWishListImageEpic,
  putWishListImageEpic as wishListsPutWishListImageEpic,
  deleteWishListEpic,
  fetchMyWishListsAfterChangeWisListsEpic,
  initialState as myWishListsInitialState,
} from './my-wish-lists/duck';
import specialProducts, {
  fetchSpecialProductsRecentProductsEpic,
  fetchSpecialProductsPopularProductsEpic,
  fetchSpecialProductsBestDealsEpic,
  fetchSpecialProductsFeaturedProductsEpic,
  initialState as specialProductsInitialState, fetchSpecialProductsStoresDealsEpic,
} from './special-products/duck';
import courier, { initialState as courierInitialState } from './courier/duck';
import { fetchReceptionOrdersEpic, receiveOrderItemEpic } from './courier/recepetion/duck';
import scrap, {
  scrapUrlEpic,
  initialState as scrapInitialState,
} from './scrap/duck';
import tiendas, {
  registerStoreEpic,
  initialState as tiendasInitialState,
} from './tiendas/duck';
import helpTicket, {
  createTicketEpic,
  initialState as helpTicketInitialState,
} from './help-ticket/duck';

import type { AuthState } from './auth/duck';
import type { NavbarState } from './navbar/duck';
import type { LocaleState } from './locale/duck';
import type { NewFlightState } from './new-flight/duck';
import type { FlightLandingState } from './flight-landing/duck';
import type { NewOrderState } from './new-order/duck';
import type { FlightsState } from './flights/duck';
import type { EditFlightState } from './edit-flight/duck';
import type { OrdersState } from './orders/duck';
import type { FlightState } from './flight/duck';
import type { LocalValuesState } from './local-values/duck';
import type { OrderState } from './order/duck';
import type { PreferencesState } from './preferences/duck';
import type { AlertState } from './alert/duck';
import type { ReserveState } from './reserve/duck';
import type { PaymentsState } from './payments/duck';
import type { HomeState } from './home/duck';
import type { UnsubscribeState } from './unsubscribe/duck';
import type { ABTestState } from './ab-test/duck';
import type { RouterState } from '../router';
import type { AuthModalsState } from './auth/auth-modals/duck';
import type { ReportState } from './report/duck';
import type { DealsState } from './best-deals/duck';
import type { StoresState } from './stores/duck';
import type { StoreState } from './store/duck';
import type { ShoppingCartState } from './shopping-cart/duck';
import type { BagState } from './bag/duck';
import type { ProductListState } from './product-list/duck';
import type { WishListState } from './wish-list/duck';
import type { FeaturedProductsState } from './featured-products/duck';
import type { PopularProductsState } from './popular-products/duck';
import type { PunchCardState } from './punch-card/duck';
import type { ProductHelperState } from './product-helper/duck';
import type { CargoState } from './cargo/duck';
import type { WishListCatalogState } from './wish-list-catalog/duck';
import type { MyWishListsState } from './my-wish-lists/duck';
import type { SpecialProductsState } from './special-products/duck';
import type { CourierState } from './courier/duck';
import type { ScrapState } from './scrap/duck';
import type { TiendasState } from './tiendas/duck';
import type { HelpTicketState } from './help-ticket/duck';

export type RootState = {
  router: RouterState;
  home: HomeState;
  unsubscribe: UnsubscribeState;
  abTest: ABTestState;
  localValues: LocalValuesState;
  auth: AuthState;
  locale: LocaleState;
  newFlight: NewFlightState;
  flightLanding: FlightLandingState;
  preferences: PreferencesState;
  editFlight: EditFlightState;
  newOrder: NewOrderState;
  flights: FlightsState;
  orders: OrdersState;
  flight: FlightState;
  navbar: NavbarState;
  order: OrderState;
  // profile: ProfileState,
  // checkout: CheckoutState;
  alert: AlertState;
  reserve: ReserveState;
  payments: PaymentsState;
  authModals: AuthModalsState;
  report: ReportState;
  deals: DealsState;
  stores: StoresState;
  store: StoreState;
  shoppingCart: ShoppingCartState;
  bag: BagState;
  productList: ProductListState;
  wishList: WishListState;
  featuredProducts: FeaturedProductsState;
  popularProducts: PopularProductsState;
  punchCard: PunchCardState;
  productHelper: ProductHelperState;
  cargo: CargoState;
  wishListCatalog: WishListCatalogState;
  myWishLists: MyWishListsState;
  specialProducts: SpecialProductsState;
  courier: CourierState;
  scrap: ScrapState;
  tiendas: TiendasState;
  helpTicket: HelpTicketState;
};

export const defaultInitialState = {
  router: ({}: any),
  home: homeInitialState,
  unsubscribe: UnsubscribeInitialState,
  abTest: ABTestInitialState,
  localValues: localValuesInitialState,
  auth: authInitialState,
  locale: localeInitialState,
  preferences: preferencesInitialState,
  newFlight: newFlightInitialState,
  flightLanding: flightLandingInitialState,
  editFlight: editFlightInitialState,
  newOrder: newOrderInitialState,
  flights: flightsInitialState,
  orders: ordersInitialState,
  flight: flightInitialState,
  /*myPayments: {
    paymentsSentPage: 0,
    paymentsReceivedPage: 0,
  },*/
  navbar: navbarInitialState,
  order: orderInitialState,
  // profile: {},
  // checkout: {},
  alert: alertInitialState,
  reserve: reserveInitialState,
  payments: paymentsInitialState,
  authModals: authModalsInitialState,
  report: reportInitialState,
  deals: dealsInitialState,
  stores: storesInitialState,
  store: storeInitialState,
  productList: productListInitialState,
  shoppingCart: shoppingCartInitialState,
  bag: bagInitialState,
  wishList: {},
  featuredProducts: featuredProductsInitialState,
  popularProducts: popularProductsInitialState,
  punchCard: punchCardInitialState,
  productHelper: productHelperInitialState,
  cargo: cargoInitialState,
  wishListCatalog: wishListCatalogInitialState,
  myWishLists: myWishListsInitialState,
  specialProducts: specialProductsInitialState,
  courier: courierInitialState,
  scrap: scrapInitialState,
  tiendas: tiendasInitialState,
  helpTicket: helpTicketInitialState,
};

export const rootEpic = combineEpics(
  // local values
  fetchCategoriesEpic,
  fetchCountriesEpic,
  fetchStoreCategoriesEpic,
  fetchOnlineStoresEpic,
  // auth
  getSessionEpic,
  setTrackingSessionEpic,
  /*setCustomSessionEpic,
  executeAfterCustomCookieSetEpic,
  executeAfterIndexCookieSetEpic,*/
  logoutCustomSessionEpic,
  loginEpic,
  loginFbEpic,
  registerEpic,
  redirectAfterSuccess,
  changeLanguageAfterSuccessEpic,
  logoutEpic,
  // home
  fetchWishListEpic,
  // subscribeEpic,
  // unsubscribe
  editHasCampaignMailNewsletterEpic,
  //navbar
  fetchNotificationsEpic,
  fetchUnseenEpic,
  readNotificationEpic,
  seeAllNotificationEpic,
  hideNotificationEpic,
  fetchNotificationsSuccessEpic,
  // preferences
  editProfileEpic,
  editImageProfileEpic,
  fetchNotificationSettingsEpic,
  editNotificationsSettingsEpic,
  fetchAddressesEpic,
  postAddressEpic,
  editAddressEpic,
  deleteAddressEpic,
  editEmailEpic,
  postPhoneEpic,
  postCodeEpic,
  editPasswordEpic,
  fetchPayoutsEpic,
  postPayoutEpic,
  postPayoutPayPalEpic,
  deletePayoutEpic,
  // fetchPaymentsEpic,
  editPaymentEpic,
  postPaymentEpic,
  deletePaymentEpic,
  // new-order
  postOrderEpic,
  postOrderImageEpic,
  redirectNewOrderToCheckoutAfterSuccess,
  // new-order/checkout
  fetchCheckoutStepOrderEpic,
  fetchNewOrderCheckoutAddressesEpic,
  fetchNewOrderCheckoutPaymentMethodsEpic,
  postNewOrderCheckoutItemsOrderAndTokenEpic,
  postNewOrderCheckoutCartOrderAndTokenEpic,
  postNewOrderCheckoutBagOrderAndTokenEpic,
  setSuccessfulCreateOrderTracking,
  putNewOrderCheckoutOrderPaymentMethodEpic,
  postNewOrderCheckoutPaymentExecuteEpic,
  newOrderCheckoutRedirectToSuccessPageEpic,
  postNewOrderCheckoutPaymentExecuteCustomHandleErrorEpic,
  newOrderCheckoutAsyncPaymentRedirectToOrderPageEpic,
  newOrderCheckoutNotFoundLibraryErrorEpic,
  newOrderCheckoutApplyCoupon,
  newOrderCheckoutRemoveCoupon,
  /*postNewOrderCheckoutAddressEpic,
  editNewOrderCheckoutAddressEpic,
  deleteNewOrderCheckoutAddressEpic,
  getLastContactInfoEpic,*/
  // new-order/checkout-success
  checkoutSuccessFetchOrderEpic,
  // new-order/scrap
  /*fetchRecentListProductsEpic,
  fetchPopularListProductsEpic,
  fetchNewOrderBestDealsEpic,
  fetchFeaturedProductsEpic,*/
  // new-order/product
  newOrderProductFetchWishListsEpic,
  newOrderProductPostProductToWishListEpic,
  newOrderProductPostProductToWishListImageEpic,
  newOrderProductPostNewWishListEpic,
  newOrderProductQuoteForecastPricesEpic,
  // new-order/quote
  newOrderQuoteForecastPricesEpic,
  newOrderQuotePostMissingCartEpic,
  newOrderQuotePostMissingSumItemsEpic,
  newOrderQuoteFetchRelatedProductsEpic,
  // new-order/search
  searchProductEpic,
  // new-flight
  postFlightEpic,
  // flight-landing
  fetchFlightLandingFlightEpic,
  saveDataLandingFlightEpic,
  // edit-flight
  fetchFlightEpic,
  editFlightEpic,
  // flights
  fetchActiveFlightsEpic,
  fetchPastFlightsEpic,
  deleteActiveFlightEpic,
  // orders
  fetchActivePurchasesEpic,
  fetchPastPurchasesEpic,
  cancelOrDeleteOrderEpic,
  // purchase::unconfirmed-paymeny
  purchaseUnconfirmedPaymentDeleteOrderEpic,
  // purchase::looking-for-traveler
  cancelOrderEpic,
  // purchase::register-purchase
  registerPurchaseUploadInvoiceFileEpic,
  registerPurchaseUploadInvoiceEpic,
  registerPurchasePostIdentityEpic,
  registerPurchaseProgressPurchaseEpic,
  // purchase::courier-flow  
  setCourierFlowTrackingNumberEpic,
  // purchase::in-transit
  postConfirmationEpic,
  // purchase::feedback
  postFeedbackEpic,
  // sale::reserved
  uploadInvoiceFileEpic,
  uploadInvoiceEpic,
  progressPurchaseEpic,
  cancelReserveEpic,
  // sale::confirmed
  confirmArrivalEpic,
  // sale::purchased
  setTrackingNumberEpic,
  confirmItemReceivedEpic,
  progressReceiveEpic,
  fetchCancellationMotivesEpic,
  cancelPurchasedItemEpic,
  // sale::deliver
  postProgressCourierInvoiceEpic,
  postProgressCourierEpic,
  postProgressQempoEpic,
  fetchCouriersEpic,
  // sale::completed
  fetchDisbursementInfoEpic,
  // fetchPayoutEpic,
  // flight
  fetchFlightFlightEpic,
  fetchAvailableRequestsEpic,
  fetchFlightSalesEpic,
  fetchTravelerRewardEpic,
  // order
  fetchOrderEpic,
  fetchMessagesEpic,
  postOrderMessageEpic,
  updateTransactionRealTimeEpic,
  // profile
  // fetchProfileEpic,
  // reserve
  fetchReserveFlightEpic,
  fetchReserveOrderEpic,
  postReserveEpic,
  updatePhoneEpic,
  // payments
  fetchPaymentsMadeEpic,
  fetchPaymentsReceivedEpic,
  // auth-modals
  fetchSessionEpic,
  resendVerificationEpic,
  sendForgotPasswordEpic,
  recoverUserEpic,
  // report
  reportEpic,
  reportImageEpic,
  motivesEpic,
  // best-deals
  fetchDealsEpic,
  // shoppingCart
  fetchShoppingCartEpic,
  deleteShoppingCartEpic,
  deleteShoppingCartItemsEpic,
  postShoppingCartItemEpic,
  postShoppingCartItemImageEpic,
  editShoppingCartItemEpic,
  deleteItemEpic,
  postVirtualShoppingCartItemEpic,
  editVirtualShoppingCartItemEpic,
  deleteVirtualCartItemEpic,
  postVirtualCartToCartDeleteEpic,
  postVirtualCartToCartImageEpic,
  postVirtualCartToCartEpic,
  forecastShoppingCartItemEpic,
  // bag
  fetchBagEpic,
  postBagItemEpic,
  postBagItemImageEpic,
  editBagItemEpic,
  deleteBagItemEpic,
  postVirtualBagItemEpic,
  editVirtualBagItemEpic,
  deleteVirtualBagItemEpic,
  postVirtualBagToBagImageEpic,
  postVirtualBagToBagEpic,
  resetBagEpic,
  // stores
  fetchStoresEpic,
  // store
  fetchStoreEpic,
  StoreGetUserWishList1Epic,
  StoreGetUserWishList2Epic,
  // product-list
  fetchProductListEpic,
  // wish-list
  getListUserWishListsEpic,
  getUserWishListEpic,
  postWishListImageEpic,
  postCreateUserWishListEpic,
  putEditUserWishListEpic,
  deleteUserWishListEpic,
  postProductEpic,
  postProductImageEpic,
  editProductEpic,
  editProductImageEpic,
  deleteProductEpic,
  editWishListLikeEpic,
  // featured-products
  // feature-products
  fetchFeaturedProductsPageEpic,
  // popular-products
  fetchPopularProductsPageEpic,
  // punch-card
  fetchPunchCardPointsEpic,
  claimPunchCardPointsEpic,
  // product-helper
  productHelperPostContactMessageEpic,
  // cargo
  cargoPostContactMessageEpic,
  // wish-list-catalog
  fetchWishListsEpic,
  // my-wish-lists
  fetchMyWishListsEpic,
  postWishListEpic,
  putWishListEpic,
  wishListsPostWishListImageEpic,
  wishListsPutWishListImageEpic,
  deleteWishListEpic,
  fetchMyWishListsAfterChangeWisListsEpic,
  // special-products
  fetchSpecialProductsRecentProductsEpic,
  fetchSpecialProductsPopularProductsEpic,
  fetchSpecialProductsBestDealsEpic,
  fetchSpecialProductsFeaturedProductsEpic,
  fetchSpecialProductsStoresDealsEpic,
  // courier
  fetchReceptionOrdersEpic,
  receiveOrderItemEpic,
  // scrap
  scrapUrlEpic,
  // tiendas
  registerStoreEpic,
  // help-ticket
  createTicketEpic,
);

export const appReducer = combineReducers({
  router: routerReducer,
  home,
  unsubscribe,
  abTest,
  localValues,
  auth,
  navbar,
  preferences,
  locale,
  newFlight,
  flightLanding,
  editFlight,
  newOrder,
  flights,
  orders,
  flight,
  order,
  // profile,
  // checkout,
  alert,
  reserve,
  payments,
  authModals,
  report,
  deals,
  stores,
  store,
  shoppingCart,
  bag,
  productList,
  wishList,
  featuredProducts,
  popularProducts,
  punchCard,
  productHelper,
  cargo,
  wishListCatalog,
  myWishLists,
  specialProducts,
  courier,
  scrap,
  tiendas,
  helpTicket,
});

export const rootReducer = (state: RootState, action: { type: string }) => {
  // Clear higher order state when logout
  if (action.type === AuthActions.AUTH_LOGOUT_REQUEST) {
    // But keep localValue (these are agnostic)
    state = { ...defaultInitialState, localValues: state.localValues, locale: state.locale, report: state.report };
  }
  return appReducer(state, action);
};



// WEBPACK FOOTER //
// ./src/modules/index.js